<template>
    <div v-if="Object.keys(model).length !== 0" class="wrapper">
        <item-form
            :model="model"
            :isEditing="true"
            @save-item="updateItem">
        </item-form>

        <b-modal title="Wijzigen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Belichtingssoort werd niet gewijzigd! {{errormsg}}
        </b-modal>
    </div>
</template>

<script>
    import api from '../../api/soortbelichting';
    import ItemForm from './Form';

    export default {
        data () {
            return {
                warningModal: false,
                errormsg: '',
                model: {
                },
            };
        },
        created () {
            api.getDetailSoortbelichting(this.$route.params.id).then((response) => {
                this.model = response.data;
            });
        },
        methods: {
            updateItem (model) {
                api.updateSoortbelichting(model).then(() => {
                    this.$router.replace('/beheer/soortbelichting');
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'item-form': ItemForm,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/soortbelichting/Edit.vue